import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DateTime } from 'luxon';
import { DateService } from '../../../../services/date/date.service';
import { PtLuxonDate } from '../../../../models/projects/date.models';

@Component({
  selector: 'pt-time-input',
  templateUrl: 'pt-time-input.html'
})

export class PtTimeInputComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() disabled: boolean;
  // @Input() ptLuxonDate: PtLuxonDate;
  // if luxonDate is null, we need some other date to check time is valid when user types in the text input - baseDate will normally be the DailyLogDate
  @Input() baseDate: DateTime;

  @Input()
  set ptLuxonDate(value: PtLuxonDate) {
    this._ptLuxonDate = value;

    if (value && value.dateTime) {
      this.timeToShow = value.dateTime.toFormat('HH:mm');
    }
  }

  @Output() inputBlurred: EventEmitter<boolean> = new EventEmitter();
  @Output() dateTimeChanged: EventEmitter<PtLuxonDate> = new EventEmitter();

  public _ptLuxonDate: PtLuxonDate;
  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  timeToShow: string;


  constructor(
    public dateService: DateService
  ) {
  }

  ngOnChanges() {

  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  // emit true when user clicks out of input
  emitBlur() {
    this.inputBlurred.next(true);
  }

  emitTimeChanged(ptLuxonDate: PtLuxonDate) {
    this.dateTimeChanged.next(ptLuxonDate);
  }

  // check user has entered a valid time
  async timeChanged(value: string) {
    const dateValidationResult = await this.dateService.validateDateTime(
      value,
      this._ptLuxonDate.dateTime || this.baseDate
    );

    if (!dateValidationResult.isValid || !dateValidationResult.ptLuxonDate.dateTime) {
      return;
    }

    this.emitTimeChanged(dateValidationResult.ptLuxonDate);
  }

  async offsetSelected(ptLuxonDate: PtLuxonDate) {
    this.emitTimeChanged(ptLuxonDate);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/pt-time-input/pt-time-input.ts